/**
 * @prettier
 */
import React, { useEffect } from 'react'
import { Route } from 'react-router-dom'

import UserEvents from './UserEvents'
import ContactInformationPage from './ContactInformationPage'
import AccountPermissions from 'app/gears/profile/components/AccountPermissions'
import OverviewPage from './OverviewPage'
import LgyLoadingIcon from 'app/components/util/lgy-loading-icon/LgyLoadingIcon'
import StatusPage from './StatusPage'
import AdminAffiliationChangeContainer from './AdminAffiliationChangePage'
import ExternalPage from './ExternalPage'

const UserAdminPage = ({
  fetchUser,
  fetchUserEvents,
  stationList,
  updateUser,
  updateUserAffiliations,
  user,
  userId
}) => {
  useEffect(() => {
    fetchUser(userId)
    fetchUserEvents(userId)
  }, [fetchUser, fetchUserEvents, userId])

  return user.id ? (
    <div className='user-admin-page'>
      <Route exact path='/lgyhub/admin/users/:userId' render={() => <OverviewPage user={user} />} />
      <Route
        exact
        path='/lgyhub/admin/users/:userId/affiliations'
        render={() => <AdminAffiliationChangeContainer user={user} updateUserAffiliations={updateUserAffiliations} />}
      />
      <Route exact path='/lgyhub/admin/users/:userId/permissions' render={() => <AccountPermissions user={user} />} />
      <Route
        exact
        path='/lgyhub/admin/users/:userId/contact'
        render={() => <ContactInformationPage user={user} stationList={stationList} updateUser={updateUser} />}
      />
      <Route
        exact
        path='/lgyhub/admin/users/:userId/events'
        render={props => <UserEvents {...props} events={user.events} />}
      />
      {/*TODO: specify props?*/}
      <Route
        exact
        path='/lgyhub/admin/users/:userId/status'
        render={() => <StatusPage user={user} updateUser={updateUser} />}
      />
      <Route
        exact
        path='/lgyhub/admin/users/:userId/external'
        render={() => <ExternalPage user={user} updateUser={updateUser} />}
      />
    </div>
  ) : (
    <LgyLoadingIcon />
  )
}
export default UserAdminPage
